<template>
  <div class="wechtLogin">
    <WechatLogo :redirectUri="redirectUri"></WechatLogo>
    <div class="topInfoRight">
      <span>{{ $t('已有账号') }}</span>
      <a @click="switchTabs('login')">{{ $t('去登录') }}</a>
    </div>
  </div>
</template>

<script>
import WechatLogo from '../base/wxlogin.vue'
export default {
  name: 'WechatLogin',
  components: {
    WechatLogo,
  },
  props: {
    backPath: {
      type: String,
      default: '',
    },
  },
  computed: {
    redirectUri() {
      const redirectUri = encodeURI(
        `https://www.yzdli.com/wechatLoginRedirect${this.backPath ? `?backPath=${this.backPath}` : ''}`,
      )
      console.log('redirectUri', redirectUri)
      return redirectUri
    },
  },
  created() {
    console.log('wechatLogin created', this.$route)
  },
  methods: {
    switchTabs(e) {
      this.$emit('switchTabs', e)
    },
  },
}
</script>
<style lang="scss" scoped>
// .tips {
//   img {
//     width: 30px;
//     height: 30px;
//   }
//   font-size: 26px;
//   font-weight: 500;
//   color: #333333;
//   line-height: 30px;
// }

.wechtLogin {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.topInfoRight {
  color: #7d7d7d;
  a {
    text-decoration: underline;
  }
}
</style>
